import React, { useEffect } from "react";
import { Card, CardContent, Box, Typography } from "@mui/material";
import "./PhoneInvoiceHeader.scss";
import { ApiLink } from "../../APILink/ApiLink";

export default function PhoneInvoiceHeader({ companiedDetails, invoiceTranslate}) {
  
  return (
    <Card className="header-section" elevation={0}>
      <CardContent className="header-section__content">
        <Box className="header-section__wrapper">
          {/* Logo */}
          <Box className="header-section__logo">
            {companiedDetails &&
                  companiedDetails.length > 0 &&
                  companiedDetails[0]?.CompanyLogo ? (
              <img
                // src={details.logoUrl}
                src={ApiLink.PHOTO_URL + companiedDetails[0].CompanyLogo}
                alt="Company Logo"
                className="header-section__logo-img"
              />
            ) : (
              <Typography
                variant="caption"
                className="header-section__logo-placeholder"
              >
                Logo
              </Typography>
            )}
          </Box>

          {/* Company Info */}
          <Box className="header-section__info">
            <Typography variant="h6" className="header-section__name">
              {/* {details.name} */}
              {invoiceTranslate.seller}:{" "}
                      {companiedDetails && companiedDetails.length > 0
                        ? companiedDetails[0].CompanyName
                        : ""}
            </Typography>
            <Typography variant="body2"> {invoiceTranslate.nui}:{" "}
                    {companiedDetails && companiedDetails.length > 0
                      ? companiedDetails[0].IdentificationNumber
                      : ""}</Typography>
            <Typography variant="body2">                  {companiedDetails &&
                  companiedDetails.length > 0 &&
                  companiedDetails[0].VATDeclarant != 0 ? (
                    <label style={{ fontSize: "12px" }}>
                      {invoiceTranslate.vatNR}: {companiedDetails[0].VATNumber}
                    </label>
                  ) : null} </Typography>
            <Typography variant="body2"> {invoiceTranslate.addres}:
                    {companiedDetails && companiedDetails.length > 0
                      ? companiedDetails[0].Address
                      : ""}</Typography>
            <Typography variant="body2"> {invoiceTranslate.phone}:
                    {companiedDetails && companiedDetails.length > 0
                      ? companiedDetails[0].PhoneNumbers
                      : ""}</Typography>
            <Typography variant="body2">{invoiceTranslate.email}:
                    {companiedDetails && companiedDetails.length > 0
                      ? companiedDetails[0].Email
                      : ""}</Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
